import React, {Component} from 'react';
import {message} from 'antd';

import {queryInvoiceInfo} from '@api/incubator/invoice';
import localDb from '@util/localDb';

import PageEdit from './PageEdit';
import PageOpen from './PageOpen';

class PageInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
    };
  }

  componentWillMount() {
    this.userUuid = localDb.get('userUuid');
  }

  componentDidMount() {
    this.invoiceInfo();
  }

  invoiceInfo = () => {
    queryInvoiceInfo({
      uuid: this.props.params.invoiceUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataInfo: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { dataInfo } = this.state;
    if (dataInfo.uuid && !dataInfo.instance && this.userUuid === dataInfo.createUser) {
      return <PageEdit data={dataInfo} {...this.props} />;
    }
    if (dataInfo.uuid) {
      return <PageOpen data={dataInfo} {...this.props} />;
    }
    return null;
  }
}
export default PageInfo;



// WEBPACK FOOTER //
// ./src/components/incubator/invoice/PageInfo.js